import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetDashboardExportReportInterface {
  startDate: string;
  endDate: string;
  type: string;
}

export const useGetDashboardGenerateReportByDateRange = () => {
  const mutate = useMutation(({ startDate, endDate, type }: GetDashboardExportReportInterface) => {
    return get(`/external-api/generate_report_bydaterange/${startDate}/${endDate}/${type}`, {
      responseType: 'blob',
    });
  });

  return mutate;
};

export default useGetDashboardGenerateReportByDateRange;
